
export const SEND_TIME_TRACKING = "SEND_TIME_TRACKING"
export const SEND_EVENT_TRACKING = "SEND_EVENT_TRACKING"

export const FEED_RECEIVED_CATEGORY = "FEED_RECEIVED_CATEGORY"
export const INSIDER_CATEGORY = "INSIDER_CATEGORY"

export const INSIDER_MPU_INFO_CLICK = "INSIDER_MPU_INFO_CLICK"
export const INSIDER_MPU_GET_INVOLVED_CLICK = "INSIDER_MPU_GET_INVOLVED_CLICK"
export const INSIDER_CTA_CLICK = "INSIDER_CTA_CLICK"
export const INSIDER_PAGE_LOGIN_CLICK = "INSIDER_PAGE_LOGIN_CLICK"
export const INSIDER_PAGE_REGISTER_CLICK = "INSIDER_PAGE_REGISTER_CLICK"

export const sendFeedReceivedTimeTracking = (metric, label, times) => {
    
    return { type: SEND_TIME_TRACKING, data: { metric, label, times, category: FEED_RECEIVED_CATEGORY } }
}

export const sendEventTracking = (category, eventAction) => {
    return { type: SEND_EVENT_TRACKING, data: {category, eventAction }}
}




// WEBPACK FOOTER //
// ./modules/Common/actions/trackingEvents.js